import { render, staticRenderFns } from "./ClientNotes.vue?vue&type=template&id=d6ed54a2&scoped=true"
import script from "./ClientNotes.vue?vue&type=script&lang=js"
export * from "./ClientNotes.vue?vue&type=script&lang=js"
import style0 from "./ClientNotes.vue?vue&type=style&index=0&id=d6ed54a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ed54a2",
  null
  
)

export default component.exports